var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-snotify'),(_vm.isLoggedIn)?_c('l-navbar'):_vm._e(),_c('div',{staticClass:"container-fluid main-container"},[_c('router-view'),_c('vue-progress-bar'),(_vm.isLoggedIn)?_c('l-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }